import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { useState } from 'react';
import styled from 'styled-components';
import useSWR from 'swr';
import { useTranslation } from '@yoweb/next-i18next';
import { Box } from '@yoweb/ui/components/Box';
import { Button } from '@yoweb/ui/components/buttons';
import { Content as FlyoutContent, FlyoutLayout, FlyoutProductDescriptionHeader } from '@poplar/components/Flyout/FlyoutTodo/common';
import { FlyoutBack } from '@poplar/components/Flyout/FlyoutBack';
import { FlyoutClose } from '@poplar/components/Flyout/FlyoutClose';
import { Text, Label, Title } from '@yoweb/ui/components/typography';
import { API_FEATURED_TASK_TEMPLATE_ID } from '@poplar/constants/routes';
import { fetcher } from '@yoweb/utils/common';
import { th } from '@yoweb/ui/styles/utils/theme';
import { media, pxToRem } from '@yoweb/ui/styles/utils';
import { ProductPageRichTextContent, CompactRichTextImageContent } from '@poplar/components/tasks/ProductPageRichTextContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ProductDescriptionSlide = function ProductDescriptionSlide(_ref) {
  var _data$richtextContent;

  var taskTemplateId = _ref.taskTemplateId,
      onSlideBack = _ref.onSlideBack,
      onSlideClose = _ref.onSlideClose,
      onStartClick = _ref.onStartClick;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState(false),
      isHeaderCompact = _useState[0],
      setIsHeaderCompact = _useState[1];

  var _useSWR = useSWR(taskTemplateId && API_FEATURED_TASK_TEMPLATE_ID(taskTemplateId), fetcher),
      data = _useSWR.data;

  var onScroll = function onScroll(e) {
    var scrollPosition = e.currentTarget.scrollTop;

    if (scrollPosition > 10) {
      setIsHeaderCompact(true);
    }
  };

  return /*#__PURE__*/_jsxs(FlyoutLayout, {
    "data-testid": "product-description-layout",
    children: [/*#__PURE__*/_jsxs(FlyoutProductDescriptionHeader, {
      heroImage: data === null || data === void 0 ? void 0 : data.bannerImageUrl,
      isCompact: isHeaderCompact,
      children: [onSlideBack && /*#__PURE__*/_jsx(FlyoutBack, {
        onClick: onSlideBack
      }), /*#__PURE__*/_jsx(FlyoutClose, {
        onClose: onSlideClose
      })]
    }), /*#__PURE__*/_jsx(Box, {
      position: "relative",
      height: "100%",
      backgroundColor: "base000",
      children: /*#__PURE__*/_jsxs(FlyoutContentLayout, {
        onScroll: onScroll,
        $padding: "none",
        children: [/*#__PURE__*/_jsxs(Box, {
          p: "normal3",
          children: [/*#__PURE__*/_jsxs(BadgeContainer, {
            children: [(data === null || data === void 0 ? void 0 : data.isTaskTemplateForDogfoodTesting) && /*#__PURE__*/_jsx(Tag, {
              isTesting: true,
              "data-testid": "tag-testing",
              children: /*#__PURE__*/_jsx(Label, {
                children: t('todo-intake.testing')
              })
            }), data === null || data === void 0 ? void 0 : data.templateBadgesList.map(function (badge) {
              return /*#__PURE__*/_jsx(Tag, {
                "data-testid": "tag-".concat(badge),
                children: /*#__PURE__*/_jsx(Label, {
                  children: badge
                })
              }, badge);
            })]
          }), /*#__PURE__*/_jsx(Box, {
            mt: "small3",
            children: /*#__PURE__*/_jsx(Title, {
              wordBreak: "break-word",
              children: data === null || data === void 0 ? void 0 : data.title
            })
          }), /*#__PURE__*/_jsx(Box, {
            mt: "small4",
            children: /*#__PURE__*/_jsx(Text, {
              wordBreak: "break-word",
              children: data === null || data === void 0 ? void 0 : data.description
            })
          }), /*#__PURE__*/_jsx(Box, {
            mt: "normal2",
            children: /*#__PURE__*/_jsx(Hr, {})
          }), /*#__PURE__*/_jsx(Box, {
            mt: "normal2",
            mb: "medium1",
            children: data === null || data === void 0 ? void 0 : (_data$richtextContent = data.richtextContent) === null || _data$richtextContent === void 0 ? void 0 : _data$richtextContent.richtextContentOptionsList.map(function (item, idx) {
              return /*#__PURE__*/_jsx(ProductPageRichTextContent // eslint-disable-next-line react/no-array-index-key
              , {
                item: item,
                Ul: Ul,
                Ol: Ol,
                Li: Li,
                RichTextImageRenderer: CompactRichTextImageContent
              }, idx);
            })
          })]
        }), /*#__PURE__*/_jsx(ActionArea, {
          children: /*#__PURE__*/_jsx(Button, {
            isFullWidth: true,
            onClick: function onClick() {
              return taskTemplateId && onStartClick(taskTemplateId);
            },
            "data-testid": "create-todo-flyout-start-todo",
            children: t('todo-intake.start-todo')
          })
        })]
      })
    })]
  });
};
var ActionArea = styled.div.withConfig({
  componentId: "sc-g56m5w-0"
})(["position:sticky;bottom:0;left:0;right:0;padding:", ";border-top:1px solid ", ";background-color:", ";"], th.getSpace('normal2'), th.getColor('base100'), th.getColor('base000'));
var FlyoutContentLayout = styled(FlyoutContent).withConfig({
  componentId: "sc-g56m5w-1"
})(["&&{display:grid;grid-template-rows:1fr max-content;}"]);
var Tag = styled.div.withConfig({
  componentId: "sc-g56m5w-2"
})(["display:inline-block;background-color:", ";padding:", ";border-radius:", ";"], function (props) {
  return props.isTesting ? th.getColor('warningLight') : th.getColor('infoLight');
}, th.getSpace('small3'), th.getRadii('tiny'));
var Hr = styled.hr.withConfig({
  componentId: "sc-g56m5w-3"
})(["background-color:", ";margin-block:0 0;border:none;height:1px;"], th.getColor('base100'));
var Ol = styled.ol.withConfig({
  componentId: "sc-g56m5w-4"
})(["margin-left:", ";margin-top:", ";list-style-type:decimal;", ""], pxToRem(20), th.getSpace('small4'), media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin-left: ", ";\n  "])), pxToRem(40)));
var Ul = styled.ul.withConfig({
  componentId: "sc-g56m5w-5"
})(["margin-left:", ";margin-top:", ";list-style-type:disc;"], pxToRem(20), th.getSpace('small4'));
var Li = styled.li.withConfig({
  componentId: "sc-g56m5w-6"
})(["padding-bottom:", ";line-height:", ";"], th.getSpace('small4'), th.getSpace('normal2'));
var BadgeContainer = styled.div.withConfig({
  componentId: "sc-g56m5w-7"
})(["div:not(:first-child){margin-left:6px;}"]);